import React from 'react';
import './Header.css'
import LogoMPO from './logo.png'
import { Link } from 'react-router-dom';

function Header() {
  return (
    <div className='header-menu'>
      <Link to='/daily-bonus'>
        <img src={LogoMPO} alt='logo' className='header-logo'/>
      </Link>
      <ul className='menu-items'>
        <li>
          <Link className='menu-button' to='/daily-bonus'>Daily Bonus</Link>
        </li>
        <li>
          <Link className='menu-button' to='./monthly-bonus'>Special Bonus</Link>
        </li>
        <li>
          <a href='https://gudangmoney.org/' title='Daftar & Main di GudangCuan' target='_blank' style={{ background: '#e0c051', color: '#000000', borderRadius: '5px', padding: '5px 15px', marginLeft: '15px' }}>DAFTAR</a>
        </li>
      </ul>
    </div>
  )
}


export default Header


